"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

var _Info = _interopRequireDefault(require("../../assets/img/Info"));

var _Headings = require("../Headings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Tooltip = _styledComponents.default.div`
	background-color: ${_constants.colours.tooltipBg};
	color: ${_constants.colours.white};
	border-radius: 6px;
	padding: 15px 20px;
	max-width: 725px;
	transform: translateY(8px);
	font-family: ${_constants.fonts.normal};
	font-size: ${_constants.fontSizes.detail2};
	line-height: 17.6px;
`;
const IconWrapper = _styledComponents.default.button`
	cursor: pointer;
	border: 0;
	outline: 0;
	background: transparent;
	position: relative;
	margin: 0 0 20px 10px;
	&::after {
		position: absolute;
		top: 25px;
		left: 4px;
		width: 24px;
		height: 24px;
		transform: rotate(45deg);
		background: ${_constants.colours.tooltipBg};
		border-radius: 5px;
		content: '';
		transition: opacity 0;
		opacity: ${props => props.open ? 1 : 0};
	}
`;
const Wrapper = _styledComponents.default.div`
	display: flex;
	align-items: center;
`;
const useStyles = (0, _core.makeStyles)(theme => ({
  popper: {
    zIndex: theme.zIndex.tooltip
  }
}));

const InfoTitle = ({
  children,
  title,
  ...otherProps
}) => {
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [open, setOpen] = (0, _react.useState)(false);
  const classes = useStyles();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  return /*#__PURE__*/_react.default.createElement(Wrapper, otherProps, /*#__PURE__*/_react.default.createElement(_Headings.H2, null, title), children && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    open: open,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    width: 18,
    height: 18,
    fillColor: open ? _constants.colours.primary : _constants.colours.black
  })), /*#__PURE__*/_react.default.createElement(_core.Popper, {
    open: open,
    anchorEl: anchorEl,
    placement: "bottom",
    transition: true,
    className: classes.popper
  }, ({
    TransitionProps
  }) => /*#__PURE__*/_react.default.createElement(_core.ClickAwayListener, {
    onClickAway: () => setOpen(!open)
  }, /*#__PURE__*/_react.default.createElement(_core.Fade, _extends({}, TransitionProps, {
    timeout: 0
  }), /*#__PURE__*/_react.default.createElement(Tooltip, null, children))))));
};

InfoTitle.propTypes = {
  title: _propTypes.default.string.isRequired
};
var _default = InfoTitle;
exports.default = _default;